export default __webpack_public_path__ + "static/media/banner-bg.ebcd88dd.jpg";